import React, { useState } from 'react';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import {
  downloadDetailedHolidayReport,
  HolidayReportLine,
  toExcelDownload
} from '@features/reporting/services/ReportingService';
import { Moment } from "moment";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function DownloadDetailedHolidayReportButton(props: Props) {
  const {selectedDate, disabled} = props;
  const [loading, setLoading] = useState(false);

  const downloadDetailedReport = async () => {
    try {
      setLoading(true);
      const reportData: HolidayReportLine[] = await downloadDetailedHolidayReport(selectedDate.year());
      toExcelDownload(reportData, `Detailed holiday report`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <OutlineButton size={ButtonSize.Medium}
                   disabled={disabled || loading}
                   text="reports-page.holidays-report.detailed-report"
                   click={downloadDetailedReport} />
  )
}

interface Props {
  selectedDate: Moment;
  disabled: boolean;
}
